import MustEat from "../mustEat/checkMustEat";

// ! player eats one pawn
export function R1_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  if (
    playerTurn == 1 &&
    boardData[prevSquareIndex][0] == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    (boardData[prevSquareIndex + 11][0] == 2 ||
      boardData[prevSquareIndex + 11][0] == 32) &&
    currentSquareIndex == prevSquareIndex + 22
  ) {
    squareRef.current[currentSquareIndex].classList.add("board-square-even");
    squareRefPawns.current[currentSquareIndex].classList.add("red-square");

    setBoardData((prevData) => {
      const newData = [...prevData];
      newData[prevSquareIndex][0] = 0;
      newData[prevSquareIndex + 11][0] = 0;
      newData[prevSquareIndex + 22][0] = 1;
      return newData;
    });
    squareRefPawns.current[prevSquareIndex + 11].classList.remove(
      "blue-square",
      "blue-square-dhama"
    );
    squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
    setPlayerTurn(2);
    return true;
  }
  return false;
}

export function L1_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {


  if (
    playerTurn == 1 &&
    boardData[prevSquareIndex][0] == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    (boardData[prevSquareIndex + 9][0] == 2 ||
      boardData[prevSquareIndex + 9][0] == 32) &&
    currentSquareIndex == prevSquareIndex + 18
  ) {

    squareRef.current[currentSquareIndex].classList.add("board-square-even");
    squareRefPawns.current[currentSquareIndex].classList.add("red-square");
    setBoardData((prevData) => {
      const newData = [...prevData];
      newData[prevSquareIndex][0] = 0;
      newData[prevSquareIndex + 9][0] = 0;
      newData[prevSquareIndex + 18][0] = 1;
      return newData;
    });
    squareRefPawns.current[prevSquareIndex + 9].classList.remove(
      "blue-square",
      "blue-square-dhama"
    );
    squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
    setPlayerTurn(2);
    return true;
  }
  return false;
}

// ! player eats on right
export function R1L3_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 9,
      prevSquareIndex + 29,
      prevSquareIndex + 51,
      prevSquareIndex + 73,
    ],
    [
      prevSquareIndex + 18,
      prevSquareIndex + 40,
      prevSquareIndex + 62,
      prevSquareIndex + 84,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -84
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -62
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
  
    if (prevSquareIndex - currentSquareIndex === -84) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -62) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -40) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}

export function R1L2R1_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 9,
      prevSquareIndex + 29,
      prevSquareIndex + 51,
      prevSquareIndex + 71,
    ],
    [
      prevSquareIndex + 18,
      prevSquareIndex + 40,
      prevSquareIndex + 62,
      prevSquareIndex + 80,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -80
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -62
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
  
    if (prevSquareIndex - currentSquareIndex === -80) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -62) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -40) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function R1L1R1L1_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 9,
      prevSquareIndex + 29,
      prevSquareIndex + 49,
      prevSquareIndex + 69,
    ],
    [
      prevSquareIndex + 18,
      prevSquareIndex + 40,
      prevSquareIndex + 58,
      prevSquareIndex + 80,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -80
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -58
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
  
    if (prevSquareIndex - currentSquareIndex === -80) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -58) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -40) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
    return false;
  }
}
export function R1L1R2_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 9,
      prevSquareIndex + 29,
      prevSquareIndex + 49,
      prevSquareIndex + 67,
    ],
    [
      prevSquareIndex + 18,
      prevSquareIndex + 40,
      prevSquareIndex + 58,
      prevSquareIndex + 76,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -76
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -58
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {

    if (prevSquareIndex - currentSquareIndex === -76) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -58) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -40) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function R4_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 9,
      prevSquareIndex + 27,
      prevSquareIndex + 45,
      prevSquareIndex + 63,
    ],
    [
      prevSquareIndex + 18,
      prevSquareIndex + 36,
      prevSquareIndex + 54,
      prevSquareIndex + 72,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -72
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -54
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
   
    if (prevSquareIndex - currentSquareIndex === -72) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -54) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -36) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function R3L1_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 9,
      prevSquareIndex + 27,
      prevSquareIndex + 45,
      prevSquareIndex + 65,
    ],
    [
      prevSquareIndex + 18,
      prevSquareIndex + 36,
      prevSquareIndex + 54,
      prevSquareIndex + 76,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -76
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -54
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    
    if (prevSquareIndex - currentSquareIndex === -76) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -54) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -36) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function R2L2_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 9,
      prevSquareIndex + 27,
      prevSquareIndex + 47,
      prevSquareIndex + 69,
    ],
    [
      prevSquareIndex + 18,
      prevSquareIndex + 36,
      prevSquareIndex + 58,
      prevSquareIndex + 80,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -80
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -58
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    if (prevSquareIndex - currentSquareIndex === -80) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -58) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -36) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function R2L1R1_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 9,
      prevSquareIndex + 27,
      prevSquareIndex + 47,
      prevSquareIndex + 67,
    ],
    [
      prevSquareIndex + 18,
      prevSquareIndex + 36,
      prevSquareIndex + 58,
      prevSquareIndex + 76,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -76
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -58
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    if (prevSquareIndex - currentSquareIndex === -76) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -58) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -36) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}

// ! player2 eats on left
export function L1R3_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 11,
      prevSquareIndex + 31,
      prevSquareIndex + 49,
      prevSquareIndex + 67,
    ],
    [
      prevSquareIndex + 22,
      prevSquareIndex + 40,
      prevSquareIndex + 58,
      prevSquareIndex + 76,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -76
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -58
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    if (prevSquareIndex - currentSquareIndex === -76) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -58) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -40) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function L1R2L1_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 11,
      prevSquareIndex + 31,
      prevSquareIndex + 49,
      prevSquareIndex + 69,
    ],
    [
      prevSquareIndex + 22,
      prevSquareIndex + 40,
      prevSquareIndex + 58,
      prevSquareIndex + 80,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -80
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -58
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    if (prevSquareIndex - currentSquareIndex === -80) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -58) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -40) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function L1R1L1R1_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 11,
      prevSquareIndex + 31,
      prevSquareIndex + 51,
      prevSquareIndex + 71,
    ],
    [
      prevSquareIndex + 22,
      prevSquareIndex + 40,
      prevSquareIndex + 62,
      prevSquareIndex + 80,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -80
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -62
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    if (prevSquareIndex - currentSquareIndex === -80) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -62) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -40) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function L1R1L2_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 11,
      prevSquareIndex + 31,
      prevSquareIndex + 51,
      prevSquareIndex + 73,
    ],
    [
      prevSquareIndex + 22,
      prevSquareIndex + 40,
      prevSquareIndex + 62,
      prevSquareIndex + 84,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -84
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -62
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    if (prevSquareIndex - currentSquareIndex === -84) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -62) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -40) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function L4_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 11,
      prevSquareIndex + 33,
      prevSquareIndex + 55,
      prevSquareIndex + 77,
    ],
    [
      prevSquareIndex + 22,
      prevSquareIndex + 44,
      prevSquareIndex + 66,
      prevSquareIndex + 88,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -88
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -66
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    if (prevSquareIndex - currentSquareIndex === -88) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -66) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -44) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function L3R1_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 11,
      prevSquareIndex + 33,
      prevSquareIndex + 55,
      prevSquareIndex + 75,
    ],
    [
      prevSquareIndex + 22,
      prevSquareIndex + 44,
      prevSquareIndex + 66,
      prevSquareIndex + 85,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -85
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -66
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    if (prevSquareIndex - currentSquareIndex === -85) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -66) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -44) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function L2R2_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 11,
      prevSquareIndex + 33,
      prevSquareIndex + 53,
      prevSquareIndex + 71,
    ],
    [
      prevSquareIndex + 22,
      prevSquareIndex + 44,
      prevSquareIndex + 62,
      prevSquareIndex + 80,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -80
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -62
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    if (prevSquareIndex - currentSquareIndex === -80) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -62) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -44) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
export function L2R1L1_P1(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData
) {
  const possibleIndicesEmptyAndPawns = [
    [
      prevSquareIndex + 11,
      prevSquareIndex + 33,
      prevSquareIndex + 53,
      prevSquareIndex + 73,
    ],
    [
      prevSquareIndex + 22,
      prevSquareIndex + 44,
      prevSquareIndex + 62,
      prevSquareIndex + 84,
    ],
  ];
  if (
    playerTurn == 1 &&
    boardData[currentSquareIndex][0] == 0 &&
    boardData[prevSquareIndex][0] === 1 &&
    possibleIndicesEmptyAndPawns[1].includes(currentSquareIndex) &&
    (prevSquareIndex - currentSquareIndex == -84
      ? possibleIndicesEmptyAndPawns[0].every(
          (index) => boardData[index][0] === 2 || boardData[index][0] === 32
        ) &&
        possibleIndicesEmptyAndPawns[1].every(
          (index) => boardData[index][0] === 0
        )
      : prevSquareIndex - currentSquareIndex == -62
      ? possibleIndicesEmptyAndPawns[0]
          .slice(0, 3)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 3)
          .every((index) => boardData[index][0] === 0)
      : possibleIndicesEmptyAndPawns[0]
          .slice(0, 2)
          .every(
            (index) => boardData[index][0] === 2 || boardData[index][0] === 32
          ) &&
        possibleIndicesEmptyAndPawns[1]
          .slice(0, 2)
          .every((index) => boardData[index][0] === 0))
  ) {
    if (prevSquareIndex - currentSquareIndex === -84) {
      possibleIndicesEmptyAndPawns[0].forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -62) {
      possibleIndicesEmptyAndPawns[0].slice(0, 3).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    } else if (prevSquareIndex - currentSquareIndex === -44) {
      possibleIndicesEmptyAndPawns[0].slice(0, 2).forEach((index) => {
        setBoardData((prevData) => {
          const newData = [...prevData];
          newData[index][0] = 0;
          return newData;
        });
        squareRefPawns.current[index].classList.remove("blue-square","blue-square-dhama");
      });
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      setPlayerTurn(2);
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      setBoardData((prevData) => {
        const newData = [...prevData];
        newData[currentSquareIndex][0] = 1;
        newData[prevSquareIndex][0] = 0;
        return newData;
      });
      return true;
    }
  }
  return false;
}
